import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { insuranceAffiliation } from '../mockData/insurance-affiliation-data';

const InsuranceAffiliationApi = [
  rest.get(`${API_ROOT}insurance-affiliations`, (req, res, ctx) => res(ctx.json(insuranceAffiliation))),
  rest.get(`${API_ROOT}insurance-affiliations/${insuranceAffiliation[0].id}`, (req, res, ctx) => res(ctx.json(insuranceAffiliation[0]))),
  rest.put(`${API_ROOT}insurance-affiliations/${insuranceAffiliation[0].id}`, (req, res, ctx) => res(ctx.json(insuranceAffiliation[0]))),
  rest.post(`${API_ROOT}insurance-affiliations`, (req, res, ctx) => res(ctx.json(insuranceAffiliation[1]))),
  rest.delete(`${API_ROOT}insurance-affiliations/${insuranceAffiliation[0].id}`, (req, res, ctx) => res(ctx.json(insuranceAffiliation[0]))),
];

export default InsuranceAffiliationApi;
